import {
	useCallback,
	useState
} from "react";
import { MobileCommentMode } from "../MobileComment/MobileComment";

export type MobileCommentState = {
	mobileMode: MobileCommentMode;
	mobileModeChangeHandler: (mode: MobileCommentMode) => void;
	initMobileMode: () => void;
};

export function useMobileCommentState(
	onFocusForm: () => void
): MobileCommentState {
	const [mobileMode, setMobileCommentMode] = useState<MobileCommentMode>(
		{ kind: "create" }
	);

	const initMobileMode = useCallback(
		(): void => {
			setMobileCommentMode({
				kind: "create"
			});
		},
		[]
	);

	const mobileModeChangeHandler = useCallback(
		(newValue: MobileCommentMode): void => {
			setMobileCommentMode(newValue);
			onFocusForm();
		},
		[onFocusForm]
	);

	return {
		mobileMode,
		mobileModeChangeHandler,
		initMobileMode,
	};
}
